import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f82ce97a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeaderHome: require('/opt/build/repo/components/section/HeaderHome.vue').default,SectionCategories: require('/opt/build/repo/components/section/Categories.vue').default,SectionNewArrivals: require('/opt/build/repo/components/section/NewArrivals.vue').default,SectionOnSale: require('/opt/build/repo/components/section/OnSale.vue').default,SectionBrandsCarousel: require('/opt/build/repo/components/section/BrandsCarousel.vue').default,SectionAbout: require('/opt/build/repo/components/section/About.vue').default})
